// src/modules/app-views/leads/pages/Init/actions/actionButton.js
// Leads are captured automatically - no "new" button needed

const leadsInitActionButton = () => {
  return null;
};

export default leadsInitActionButton;
